import type {
  Domain,
  Question,
  QuestionDifficulty,
  QuestionStatus,
  QuestionType,
  Stage,
} from '@baby/shared'

export type AdminRole = 'SUPER' | 'CONTENT' | 'ANALYST' | 'REVIEWER'

export const ROLE_LABELS: Record<AdminRole, string> = {
  SUPER: '超级管理员',
  CONTENT: '内容运营',
  ANALYST: '数据分析',
  REVIEWER: '复核专家',
}

export interface QuestionStat {
  questionId: string
  totalCount: number
  wrongCount: number
  hookCount: number
}

export interface QuestionRow extends Question {
  updatedAt: string
  publishedAt: string | null
  stat: QuestionStat | null
}

export interface QuestionRevision {
  id: string
  action: string
  operatorId: string
  comment: string | null
  createdAt: string
}

export interface QuestionDetail extends QuestionRow {
  revisions: QuestionRevision[]
  tickets: { id: string; reason: string; status: string; createdAt: string }[]
  performance: {
    sampleSize: number
    reliable: boolean
    wrongRate: number | null
    discrimination: number | null
    topGroupCorrectRate: number | null
    bottomGroupCorrectRate: number | null
    currentDifficulty: number
    recommendedDifficulty: QuestionDifficulty | null
    optionSelections: Array<{ index: number; count: number; rate: number }>
  }
}

export interface Paged<T> {
  total: number
  page: number
  pageSize: number
  items: T[]
}

export interface QuestionQuery {
  status?: QuestionStatus
  domain?: Domain
  stage?: Stage
  type?: QuestionType
  difficulty?: number
  isTrap?: boolean
  needsExpertReview?: boolean
  keyword?: string
  page?: number
  pageSize?: number
  sortBy?: 'wrongRate'
  sortOrder?: 'asc' | 'desc'
}

export interface CoverageCount {
  active: number
  content: number
}

export interface QuestionCoverageStage {
  stage: Stage
  pool: CoverageCount
  exclusive: CoverageCount
  domains: Record<Domain, CoverageCount>
  difficulties: Record<QuestionDifficulty, CoverageCount>
  types: Record<QuestionType, CoverageCount>
  activeGapCount: number
  ready: boolean
}

export interface QuestionCoverageRes {
  generatedAt: string
  targets: {
    stagePool: number
    stageExclusive: number
    domain: number
    difficulty: number
  }
  totals: CoverageCount & {
    all: number
    statusCounts: Record<QuestionStatus, number>
  }
  stages: QuestionCoverageStage[]
}

export type TransitionAction = 'SUBMIT_REVIEW' | 'APPROVE' | 'REJECT' | 'PUBLISH' | 'ARCHIVE'

export interface BulkReviewResult {
  approvedCount: number
  ids: string[]
}

export interface BulkPublishResult {
  publishedCount: number
  ids: string[]
}
